import { Note } from '../models';
import { ModelResource } from './resource';

export interface CreateNoteData {
  content: string;

  partner?: string;

  dispute?: string;
}

export interface UpdateNoteData {
  content?: string;

  pinned?: boolean;
}

export class Notes extends ModelResource<Note, CreateNoteData> {
  model = Note;

  resourcePath = 'v1/notes';
}
